import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialBlockInstagramIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialBlockInstagram",
    children: /*#__PURE__*/_jsx("path", {
      d: "M21.7 16c0 3.15-2.55 5.7-5.7 5.7s-5.7-2.55-5.7-5.7 2.55-5.7 5.7-5.7 5.7 2.55 5.7 5.7m8.21-6.9a9.6 9.6 0 0 0-.61-3.23l.02.06c-.29-.77-.73-1.42-1.28-1.96-.53-.55-1.18-.99-1.91-1.27h-.04c-.94-.37-2.03-.59-3.17-.6-1.8-.1-2.34-.1-6.9-.1s-5.09 0-6.9.1c-1.14.02-2.23.23-3.23.61l.06-.02c-.77.29-1.42.73-1.96 1.28-.55.54-.99 1.19-1.27 1.92v.04c-.37.94-.59 2.02-.6 3.16-.1 1.82-.1 2.35-.1 6.91s0 5.1.1 6.9c.02 1.14.23 2.23.61 3.23l-.02-.06c.29.77.73 1.42 1.28 1.96.54.56 1.19.99 1.92 1.27h.04c.94.37 2.02.59 3.16.6 1.81.1 2.35.1 6.9.1s5.1 0 6.9-.1c1.14-.02 2.23-.23 3.23-.61l-.06.02a5.7 5.7 0 0 0 3.22-3.19v-.04c.37-.94.59-2.02.61-3.16.11-1.82.11-2.35.11-6.92s0-5.09-.1-6.9Zm-13.9 15.68c-4.84 0-8.76-3.93-8.76-8.77s3.92-8.77 8.77-8.77 8.76 3.92 8.77 8.75c0 4.85-3.92 8.78-8.77 8.78h-.01Zm9.12-15.84c-1.13 0-2.05-.92-2.05-2.05s.92-2.05 2.05-2.05 2.05.92 2.05 2.05-.92 2.05-2.05 2.05"
    })
  }));
};
SocialBlockInstagramIcon.displayName = 'SocialBlockInstagramIcon';